module.exports = __webpack_public_path__ + "img/ICONE-ROND2.43375136.svg";